import { Effect, Reducer, Subscription } from 'umi';
import {
  OVERVIEW_DAILY_REGION, OVERVIEW_DAILY_METRICS,
  OVERVIEW_WEEK_REGION, OVERVIEW_WEEK_METRICS,
  OVERVIEW_MONTH_REGION, OVERVIEW_MONTH_METRICS,
  OVERVIEW_DAILY_KEY_METRICS,
  OVERVIEW_WEEKLY_KEY_METRICS,
  OVERVIEW_MONTHLY_KEY_METRICS,
  OVERVIEW_DAILY_KEY_METRICS_TREND,
  OVERVIEW_WEEKLY_KEY_METRICS_TREND,
  OVERVIEW_MONTHLY_KEY_METRICS_TREND,
  PC_OVERVIEW_DAILY_METRICS,
  PC_OVERVIEW_DAILY_REGION,
  PC_OVERVIEW_DAILY_KEY_METRICS,
  PC_OVERVIEW_DAILY_KEY_METRICS_TREND,
} from './_config/filterDvaKey';

export const namespace = 'overview';

const DashboardModel = {
  namespace: namespace,
  state: {
    data: {}
  },

  effects: {
    // 获取游戏列表
    *getRegionDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveRegionData", payload: { [OVERVIEW_DAILY_REGION]: payload } });
      } catch (e) {
        yield put({
          type: "saveRegionData", payload: {

          }
        });
      }
    },

    *getWeekRegionDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveWeekRegionData", payload: { [OVERVIEW_WEEK_REGION]: payload } });
      } catch (e) {
        yield put({
          type: "saveWeekRegionData", payload: {

          }
        });
      }
    },

    *getMonthRegionDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveMonthRegionData", payload: { [OVERVIEW_MONTH_REGION]: payload } });
      } catch (e) {
        yield put({
          type: "saveMonthRegionData", payload: {

          }
        });
      }
    },
    *getMetricsDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveMetricsData", payload: { [OVERVIEW_DAILY_METRICS]: payload } });
      } catch (e) {
        yield put({
          type: "saveMetricsData", payload: {

          }
        });
      }
    },
    *getWeekMetricsDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveWeekMetricsData", payload: { [OVERVIEW_WEEK_METRICS]: payload } });
      } catch (e) {
        yield put({
          type: "saveWeekMetricsData", payload: {

          }
        });
      }
    },
    *getMonthMetricsDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "saveMonthMetricsData", payload: { [OVERVIEW_MONTH_METRICS]: payload } });
      } catch (e) {
        yield put({
          type: "saveMonthMetricsData", payload: {

          }
        });
      }
    },
    // 获取Key Performance Metrics - Daily
    *getDailyKeyPerformanceMetrics({ payload }, { put }) {
      try {
        yield put({ type: "saveDailyKeyMetricsData", payload: {[OVERVIEW_DAILY_KEY_METRICS]: payload}});
      } catch (e) {
        yield put({ type: "saveDailyKeyMetricsData", payload: {
          
        }});
      }
    },
    // 获取Key Performance Metrics - Weekly
    *getWeeklyKeyPerformanceMetrics({ payload }, { put }) {
      try {
        yield put({ type: "saveWeeklyKeyMetricsData", payload: {[OVERVIEW_WEEKLY_KEY_METRICS]: payload}});
      } catch (e) {
        yield put({ type: "saveWeeklyKeyMetricsData", payload: {
          
        }});
      }
    },
    // 获取Key Performance Metrics - Monthly
    *getMonthlyKeyPerformanceMetrics({ payload }, { put }) {
      try {
        yield put({ type: "saveMonthlyKeyMetricsData", payload: {[OVERVIEW_MONTHLY_KEY_METRICS]: payload}});
      } catch (e) {
        yield put({ type: "saveMonthlyKeyMetricsData", payload: {
          
        }});
      }
    },
    // 获取Daily - Key Performance Metrics 趋势图
    *loadMetricsTrend({ payload }, { put }) {
      try {
        yield put({ type: "saveDailyLoadMetricsTrend", payload: {[OVERVIEW_DAILY_KEY_METRICS_TREND]: payload}});
      } catch (e) {
        yield put({ type: "saveDailyLoadMetricsTrend", payload: {
          
        }});
      }
    },
    // 获取Weekly - Key Performance Metrics 趋势图
    *loadWeeklyMetricsTrend({ payload }, { put }) {
      try {
        yield put({ type: "saveWeeklyLoadMetricsTrend", payload: {[OVERVIEW_WEEKLY_KEY_METRICS_TREND]: payload}});
      } catch (e) {
        yield put({ type: "saveWeeklyLoadMetricsTrend", payload: {
          
        }});
      }
    },
    // 获取Monthly - Key Performance Metrics 趋势图
    *loadMonthlyMetricsTrend({ payload }, { put }) {
      try {
        yield put({ type: "saveMonthlyLoadMetricsTrend", payload: {[OVERVIEW_MONTHLY_KEY_METRICS_TREND]: payload}});
      } catch (e) {
        yield put({ type: "saveMonthlyLoadMetricsTrend", payload: {
          
        }});
      }
    },

    // PC Console 模块
    *getPcMetricsDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "savePcMetricsData", payload: { [PC_OVERVIEW_DAILY_METRICS]: payload } });
      } catch (e) {
        yield put({
          type: "savePcMetricsData", payload: {

          }
        });
      }
    },
    // 获取Daily - Key Performance Metrics 趋势图
    *loadPcMetricsTrend({ payload }, { put }) {
      try {
        yield put({ type: "savePcDailyLoadMetricsTrend", payload: {[PC_OVERVIEW_DAILY_KEY_METRICS_TREND]: payload}});
      } catch (e) {
        yield put({ type: "savePcDailyLoadMetricsTrend", payload: {
          
        }});
      }
    },
    *getPcRegionDataFunc({ payload }, { put }) {
      try {
        yield put({ type: "savePcRegionData", payload: { [PC_OVERVIEW_DAILY_REGION]: payload } });
      } catch (e) {
        yield put({
          type: "savePcRegionData", payload: {

          }
        });
      }
    },
    // 获取Key Performance Metrics - Daily
    *getPcDailyKeyPerformanceMetrics({ payload }, { put }) {
      try {
        yield put({ type: "savePcDailyKeyMetricsData", payload: {[PC_OVERVIEW_DAILY_KEY_METRICS]: payload}});
      } catch (e) {
        yield put({ type: "savePcDailyKeyMetricsData", payload: {
          
        }});
      }
    },
  },
  reducers: {
    saveRegionData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    saveWeekRegionData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    saveMonthRegionData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    saveMetricsData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    saveWeekMetricsData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    saveMonthMetricsData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    saveDailyKeyMetricsData(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveWeeklyKeyMetricsData(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveMonthlyKeyMetricsData(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveDailyLoadMetricsTrend(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveWeeklyLoadMetricsTrend(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    saveMonthlyLoadMetricsTrend(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },

    // PC Console 模块
    savePcMetricsData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }
      };
    },
    savePcDailyLoadMetricsTrend(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
    savePcRegionData(state, action: any) {
      return {
        ...state,
        data: { ...state.data, ...action.payload }

      };
    },
    savePcDailyKeyMetricsData(state, action: any) {
      return {
        ...state,
        data:{...state.data,...action.payload}
      };
    },
  }
};

export default DashboardModel;
